import React, { useEffect, useMemo } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
// React Bootstrap components
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import "./PartnerServiceCapabilities.scss";
import { Typography } from "@mui/material";
import Chip from "@mui/material/Chip";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import Grid from "@mui/material/Grid";
import PartnerDropDown from "./PartnerDropDown";
import { getDiscoveryMarketByPartner } from "../../API/endpoints/Discovery";
import { getFlagIcon } from "../../common/helpers";
import DueDiligenceDropDown from "./DueDiligenceDropDown";
import DeletePopup from "../components/PopupTemplate/PopupTemplate";
import {
  deleteDueDiligence,
  restoreDueDiligence,
  softDeleteDueDiligence,
} from "../../API/endpoints/DueDIligence";
import { getPartnerByID } from "../../API/endpoints/Partner";
import EmptyContent from "../components/empty/EmptyContent";
import Cookies from "js-cookie";
import { GetUserProfile } from "../../API/endpoints/User";
const PartnerServicePoc = () => {
  const params = useParams();
  const navigate = useNavigate();

  const [userID, setUserID] = React.useState<string | undefined>("");
  const [userProfile, setUserProfile] = React.useState<any>({});

  const [dueDiligenceList, setDueDiligenceList] = React.useState([]);
  const [popupType, setPopupType] = React.useState<string>("");
  const [popupHeader, setPopupHeader] = React.useState<string>("");
  const [popupBody, setPopupBody] = React.useState<string>("");
  const [deleteID, setDeleteID] = React.useState<any>();
  const [deletePopup, setDeletePopup] = React.useState(false);
  const [flag, setFlag] = React.useState(false);
  const [partnerName, setPartnerName] = React.useState("");

  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);

  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID]);

  useEffect(() => {
    if (params?.partnerId && params?.countryId) {
      const marketReq = {
        partner_id: params?.partnerId,
        country: params?.countryId,
      };
      getDiscoveryMarketByPartner(marketReq)
        .then((res) => {
          setPartnerName(
            res.data?.rows?.length > 0 ? res.data?.rows[0]?.partnerv2?.name : ""
          );
          setDueDiligenceList(
            res.data.rows.reduce(
              (prev: any, item: any) => [
                ...prev,
                ...item?.due_diigence.map((data: any) => {
                  return {
                    ...data,
                    country: item?.country?.name,
                    service_capabilities: item?.service_capabilities
                      ? item.service_capabilities
                      : [],
                  };
                }),
              ],
              []
            )
          );
        })
        .catch((err) => console.log("err", err));
    } else if (params?.partnerId) {
      getPartnerByID(params?.partnerId).then((res: any) => {
        setPartnerName(res.data?.name);
        setDueDiligenceList(
          res.data.market.reduce(
            (prev: any, item: any) => [
              ...prev,
              ...item?.due_diigence.map((data: any) => {
                return {
                  ...data,
                  country: item?.country?.name,
                  service_capabilities: item?.service_capabilities
                    ? item.service_capabilities
                    : [],
                };
              }),
            ],
            []
          )
        );
      });
    }
  }, [params, flag]);

  const onHandleEdit = (id: any) => {
    if (params?.partnerId && params?.countryId) {
      navigate(
        `/DueDiligenceAdd/${params?.brandName}/${params?.partnerId}/${params?.countryId}/${params?.marketId}/${id}`
      );
    } else if (params?.partnerId) {
      navigate(
        `/DueDiligenceAdd/${params?.partnerId}/${
          params?.toComplete ? true : false
        }/${id}`
      );
    }
  };

  const onHandleDelete = (id: any) => {
    setPopupType("delete");
    setPopupHeader("Confirm Due Diligence Deletion");
    setPopupBody("Are you sure you want to delete due diligence ?");
    setDeleteID(id);
    setDeletePopup(true);
  };
  const onHandleDeletePermanently = (id: any) => {
    setPopupType("delete-permanently");
    setPopupHeader("Confirm Permanent Due Diligence Deletion");
    setPopupBody("Are you sure you want to delete due diligence permanently ?");
    setDeleteID(id);
    setDeletePopup(true);
  };

  const onHandleRestore = (id: any) => {
    setPopupType("restore");
    setPopupHeader("Confirm Restore");
    setPopupBody("Are you sure you want to restore due diligence ?");
    setDeleteID(id);
    setDeletePopup(true);
  };

  const handleCloseDeletePopup = () => {
    setDeletePopup(false);
    setDeleteID("");
  };

  const onDeleteItem = (id: any) => {
    setDeletePopup(false);
    setDeleteID("");
    softDeleteDueDiligence(id)
      .then(async (res) => {
        setDeletePopup(false);
        setDeleteID("");
        setFlag(!flag);
      })
      .catch((err) => {
        console.log(err);
        setDeletePopup(false);
        setDeleteID("");
      });
  };

  const onPermanentDeleteItem = (id: any) => {
    setDeletePopup(false);
    setDeleteID("");
    deleteDueDiligence(id)
      .then(async (res) => {
        setDeletePopup(false);
        setDeleteID("");
        setFlag(!flag);
      })
      .catch((err) => {
        console.log(err);

        setDeletePopup(false);
        setDeleteID("");
      });
  };

  const onRestoreItem = async (id: any) => {
    setDeletePopup(false);
    setDeleteID("");
    restoreDueDiligence(id)
      .then(async (res) => {
        setDeletePopup(false);
        setDeleteID("");
        setFlag(!flag);
      })
      .catch((err) => {
        console.log(err);
        setDeletePopup(false);
        setDeleteID("");
      });
  };

  const dueDigilences = useMemo(() => {
    return dueDiligenceList.map((item: any) => {
      return (
        <Accordion defaultExpanded key={item?.id}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <div className="align-center fullwidth d-flex pl20px">
              {getFlagIcon(item?.country)}
              <Typography className="mx-05">{item?.country}</Typography>
              {item?.is_deleted && (
                <Chip
                  label="Deleted"
                  color="error"
                  variant="outlined"
                  size="small"
                />
              )}

              <div className="ml-auto pos">
                {params?.mode && params?.mode === "view" ? (
                  <></>
                ) : userProfile?.user_type &&
                  userProfile?.user_type !== "consultant" ? (
                  <DueDiligenceDropDown
                    onEditItem={onHandleEdit}
                    onDeleteItem={onHandleDelete}
                    onRestoreItem={onHandleRestore}
                    onHardDeleteItem={onHandleDeletePermanently}
                    id={item?.id}
                    isDeleted={item?.is_deleted}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Row className="bt-gray200 row-input pl8px">
              <Col sm={4} md={4} lg={4}>
                <Row className="my-8">
                  <Typography
                    sx={{
                      fontWeight: "500",
                      color: "#344054",
                      fontSize: "14px",
                    }}
                  >
                    Basis
                  </Typography>
                </Row>
              </Col>
              <Col sm={2} md={2} lg={2}>
                <Row className="my-8">
                  <Typography
                    sx={{
                      fontWeight: "500",
                      color: "#344054",
                      fontSize: "14px",
                    }}
                  >
                    Rating out of 10
                  </Typography>
                </Row>
              </Col>
              <Col sm={6} md={6} lg={6}>
                <Row className="my-8">
                  <Typography
                    sx={{
                      fontWeight: "500",
                      color: "#344054",
                      fontSize: "14px",
                    }}
                  >
                    Remarks
                  </Typography>
                </Row>
              </Col>
            </Row>
            {item?.service_capabilities?.includes("regulatory_compliance") && (
              <Row className="bt-gray200 row-input pl8px">
                <Col sm={4} md={4} lg={4}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#344054",
                        fontSize: "14px",
                      }}
                    >
                      Regulatory Compliance
                    </Typography>
                  </Row>
                </Col>
                <Col sm={2} md={2} lg={2}>
                  <Row className="my-8">
                    {item?.regulatory_compliance_rating && (
                      <Chip
                        sx={{
                          width: "auto",
                          border: "1px solid #F2F4F7",
                          background: "#F9FAFB",
                        }}
                        size="small"
                        label={item?.regulatory_compliance_rating?.toFixed(2)}
                      />
                    )}
                  </Row>
                </Col>
                <Col sm={6} md={6} lg={6}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "normal",
                        color: "#344054",
                        fontSize: "12px",
                      }}
                    >
                      {item?.regulatory_compliance_remarks}
                    </Typography>
                  </Row>
                </Col>
              </Row>
            )}

            {item?.service_capabilities?.includes("warehousing_storage") && (
              <Row className="bt-gray200 row-input pl8px">
                <Col sm={4} md={4} lg={4}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#344054",
                        fontSize: "14px",
                      }}
                    >
                      Warehousing and Storage
                    </Typography>
                  </Row>
                </Col>
                <Col sm={2} md={2} lg={2}>
                  <Row className="my-8">
                    {item?.warehousing_storage_rating && (
                      <Chip
                        sx={{
                          width: "auto",
                          border: "1px solid #F2F4F7",
                          background: "#F9FAFB",
                        }}
                        size="small"
                        label={item?.warehousing_storage_rating?.toFixed(2)}
                      />
                    )}
                  </Row>
                </Col>
                <Col sm={6} md={6} lg={6}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "normal",
                        color: "#344054",
                        fontSize: "12px",
                      }}
                    >
                      {item?.warehousing_storage_remarks}
                    </Typography>
                  </Row>
                </Col>
              </Row>
            )}

            {item?.service_capabilities?.includes("retail_distribution") && (
              <Row className="bt-gray200 row-input pl8px">
                <Col sm={4} md={4} lg={4}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#344054",
                        fontSize: "14px",
                      }}
                    >
                      Retail Distribution
                    </Typography>
                  </Row>
                </Col>
                <Col sm={2} md={2} lg={2}>
                  <Row className="my-8">
                    {item?.retail_distribuion_rating && (
                      <Chip
                        sx={{
                          width: "auto",
                          border: "1px solid #F2F4F7",
                          background: "#F9FAFB",
                        }}
                        size="small"
                        label={item?.retail_distribuion_rating?.toFixed(2)}
                      />
                    )}
                  </Row>
                </Col>
                <Col sm={6} md={6} lg={6}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "normal",
                        color: "#344054",
                        fontSize: "12px",
                      }}
                    >
                      {item?.retail_distribuion_remarks}
                    </Typography>
                  </Row>
                </Col>
              </Row>
            )}

            {item?.service_capabilities?.includes("order_fulfilment") && (
              <Row className="bt-gray200 row-input pl8px">
                <Col sm={4} md={4} lg={4}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#344054",
                        fontSize: "14px",
                      }}
                    >
                      Order Fulfillment
                    </Typography>
                  </Row>
                </Col>
                <Col sm={2} md={2} lg={2}>
                  <Row className="my-8">
                    {item?.order_fulfillment_rating && (
                      <Chip
                        sx={{
                          width: "auto",
                          border: "1px solid #F2F4F7",
                          background: "#F9FAFB",
                        }}
                        size="small"
                        label={item?.order_fulfillment_rating?.toFixed(2)}
                      />
                    )}
                  </Row>
                </Col>
                <Col sm={6} md={6} lg={6}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "normal",
                        color: "#344054",
                        fontSize: "12px",
                      }}
                    >
                      {item?.order_fulfillment_remarks}
                    </Typography>
                  </Row>
                </Col>
              </Row>
            )}

            {item?.service_capabilities?.includes("importation_clearance") && (
              <Row className="bt-gray200 row-input pl8px">
                <Col sm={4} md={4} lg={4}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#344054",
                        fontSize: "14px",
                      }}
                    >
                      Importance and Clearance
                    </Typography>
                  </Row>
                </Col>
                <Col sm={2} md={2} lg={2}>
                  <Row className="my-8">
                    {item?.importation_clearance_rating && (
                      <Chip
                        sx={{
                          width: "auto",
                          border: "1px solid #F2F4F7",
                          background: "#F9FAFB",
                        }}
                        size="small"
                        label={item?.importation_clearance_rating?.toFixed(2)}
                      />
                    )}
                  </Row>
                </Col>
                <Col sm={6} md={6} lg={6}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "normal",
                        color: "#344054",
                        fontSize: "12px",
                      }}
                    >
                      {item?.importation_clearance_remarks}
                    </Typography>
                  </Row>
                </Col>
              </Row>
            )}

            {item?.service_capabilities?.includes("marketing") && (
              <Row className="bt-gray200 row-input pl8px">
                <Col sm={4} md={4} lg={4}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#344054",
                        fontSize: "14px",
                      }}
                    >
                      Marketing
                    </Typography>
                  </Row>
                </Col>
                <Col sm={2} md={2} lg={2}>
                  <Row className="my-8">
                    {item?.marketing_rating && (
                      <Chip
                        sx={{
                          width: "auto",
                          border: "1px solid #F2F4F7",
                          background: "#F9FAFB",
                        }}
                        size="small"
                        label={item?.marketing_rating?.toFixed(2)}
                      />
                    )}
                  </Row>
                </Col>
                <Col sm={6} md={6} lg={6}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "normal",
                        color: "#344054",
                        fontSize: "12px",
                      }}
                    >
                      {item?.marketing_remarks}
                    </Typography>
                  </Row>
                </Col>
              </Row>
            )}

            {item?.service_capabilities?.includes("ecom_setup_mgmt") && (
              <Row className="bt-gray200 row-input pl8px">
                <Col sm={4} md={4} lg={4}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#344054",
                        fontSize: "14px",
                      }}
                    >
                      E-Commerce Setup and Management
                    </Typography>
                  </Row>
                </Col>
                <Col sm={2} md={2} lg={2}>
                  <Row className="my-8">
                    {item?.ecom_setup_and_management_rating && (
                      <Chip
                        sx={{
                          width: "auto",
                          border: "1px solid #F2F4F7",
                          background: "#F9FAFB",
                        }}
                        size="small"
                        label={item?.ecom_setup_and_management_rating?.toFixed(
                          2
                        )}
                      />
                    )}
                  </Row>
                </Col>
                <Col sm={6} md={6} lg={6}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "normal",
                        color: "#344054",
                        fontSize: "12px",
                      }}
                    >
                      {item?.ecom_setup_and_management_remarks}
                    </Typography>
                  </Row>
                </Col>
              </Row>
            )}

            <Row className="bt-gray200 row-input pl8px">
              <Col sm={4} md={4} lg={4}>
                <Row className="my-8">
                  <Typography
                    sx={{
                      fontWeight: "500",
                      color: "#344054",
                      fontSize: "14px",
                    }}
                  >
                    Qualitative Analysis
                  </Typography>
                </Row>
              </Col>
              <Col sm={2} md={2} lg={2}></Col>
              <Col sm={6} md={6} lg={6}></Col>
            </Row>
            <Row className="bt-gray200 row-input pl8px">
              <Col sm={4} md={4} lg={4}>
                <Row className="my-8">
                  <Typography
                    sx={{
                      fontWeight: "500",
                      color: "#344054",
                      fontSize: "14px",
                    }}
                  >
                    Responsiveness
                  </Typography>
                </Row>
              </Col>
              <Col sm={2} md={2} lg={2}>
                <Row className="my-8">
                  {item?.responsiveness_rating && (
                    <Chip
                      sx={{
                        width: "auto",
                        border: "1px solid #F2F4F7",
                        background: "#F9FAFB",
                      }}
                      size="small"
                      label={item.responsiveness_rating?.toFixed(2)}
                    />
                  )}
                </Row>
              </Col>
              <Col sm={6} md={6} lg={6}>
                <Row className="my-8">
                  <Typography
                    sx={{
                      fontWeight: "normal",
                      color: "#344054",
                      fontSize: "12px",
                    }}
                  >
                    {item?.responsiveness_remarks}
                  </Typography>
                </Row>
              </Col>
            </Row>
            <Row className="bt-gray200 row-input pl8px">
              <Col sm={4} md={4} lg={4}>
                <Row className="my-8">
                  <Typography
                    sx={{
                      fontWeight: "500",
                      color: "#344054",
                      fontSize: "14px",
                    }}
                  >
                    Evaluation Criteria
                  </Typography>
                </Row>
              </Col>
              <Col sm={2} md={2} lg={2}>
                <Row className="my-8">
                  {item?.evaluation_criteria_rating && (
                    <Chip
                      sx={{
                        width: "auto",
                        border: "1px solid #F2F4F7",
                        background: "#F9FAFB",
                      }}
                      size="small"
                      label={item?.evaluation_criteria_rating?.toFixed(2)}
                    />
                  )}
                </Row>
              </Col>
              <Col sm={6} md={6} lg={6}>
                <Row className="my-8">
                  <Typography
                    sx={{
                      fontWeight: "normal",
                      color: "#344054",
                      fontSize: "12px",
                    }}
                  >
                    {item?.evaluation_criteria_remarks}
                  </Typography>
                </Row>
              </Col>
            </Row>
          </AccordionDetails>
          {item?.remarks && (
            <Col className="bt-gray200 mx-2 py-8">
              <Typography
                sx={{
                  fontWeight: "500",
                  color: "#344054",
                  fontSize: "14px",
                }}
              >
                General Remarks
              </Typography>
              <Typography sx={{ fontSize: "12px", color: "#667085" }}>
                {item?.remarks}
              </Typography>
            </Col>
          )}
        </Accordion>
      );
    });
  }, [dueDiligenceList]);

  return (
    <div className="mt-32px">
      <Container fluid className="container-1">
        <Grid container direction="row" justifyContent="space-between">
          <Row style={{ width: "100%" }}>
            <Col className="breadcrumb-nav">
              <Breadcrumb>
                {params?.partnerId && params?.countryId ? (
                  <>
                    <Breadcrumb.Item
                      className="font12-regular gray-500"
                      onClick={() => navigate(-3)}
                    >
                      DISCOVERY MANAGEMENT
                    </Breadcrumb.Item>
                    <Breadcrumb.Item
                      className="font12-regular gray-500"
                      onClick={() => navigate(-2)}
                    >
                      {params?.brandName}
                    </Breadcrumb.Item>
                  </>
                ) : (
                  <Breadcrumb.Item className="font12-regular gray-500">
                    <Link to="/PartnerManagement">Partner MANAGEMENT</Link>
                  </Breadcrumb.Item>
                )}

                <Breadcrumb.Item
                  className="font12-medium gray-800"
                  onClick={() => {
                    if (params?.partnerId && params?.countryId) {
                      navigate(-1);
                    } else {
                      navigate(`/partner/${params?.partnerId}`);
                    }
                  }}
                >
                  {partnerName}
                </Breadcrumb.Item>
                <Breadcrumb.Item className="font12-medium gray-800" active>
                  due diligence
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            <Col md="auto">
              {params?.mode && params?.mode === "view" ? (
                <></>
              ) : userProfile?.user_type &&
                userProfile?.user_type !== "consultant" ? (
                <Link
                  to={
                    params?.partnerId && params?.countryId
                      ? `/DueDiligenceAdd/${params?.brandName}/${params?.partnerId}/${params?.countryId}/${params?.marketId}`
                      : `/DueDiligenceAdd/${params?.partnerId}/${
                          params?.toComplete ? true : false
                        }`
                  }
                  className="badgepill-blue50  blue-text br-0 bold no-border d-flex h-38 align-center"
                >
                  <AddIcon sx={{ fontSize: "22px", fontWeight: "500" }} />
                  <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
                    Add Due Diligenece
                  </Typography>
                </Link>
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </Grid>

        {dueDigilences && dueDiligenceList.length > 0 ? (
          dueDigilences
        ) : (
          <div style={{ marginTop: "120px" }}>
            <EmptyContent message="No Due Diligence Found" />
          </div>
        )}
      </Container>
      <DeletePopup
        popupHeader={popupHeader}
        popupBody={popupBody}
        isModalOpen={deletePopup}
        onCancel={handleCloseDeletePopup}
        id={deleteID}
        handleFunction={
          popupType === "restore"
            ? onRestoreItem
            : popupType === "delete"
            ? onDeleteItem
            : onPermanentDeleteItem
        }
        isRestore={popupType === "restore" ? true : false}
      />
    </div>
  );
};

export default PartnerServicePoc;
